module.exports = __webpack_public_path__ + "assets/img/3dcf9a252fc08fa581112c6f89c088c8.svg";